// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "container-2A_dW";
var _5 = "title-NSAcE";
var _6 = "services-16n2g";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "container", _5 as "title", _6 as "services" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "container": _4, "title": _5, "services": _6 }
